import {injectable} from "inversify";
import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {TutorialType} from "data/enums";
import {HP_TUTORIAL} from "data/constants";

export interface ITutorialStore extends ViewController {
	get tutorial(): TutorialType | null;
	get activeStep(): number;
	openTutorial: (type: TutorialType) => void;
	closeTutorial: () => void;
	setActiveStep: (step: number) => void;
}

@injectable()
export class TutorialStore implements ITutorialStore {
	@observable _visibleTutorial: TutorialType | null = null;
	@observable private _activeStep: number = 0;

	constructor() {
		makeAutoObservable(this);
	}

	get tutorial() {
		return this._visibleTutorial;
	}

	get activeStep() {
		return this._activeStep;
	}

	openTutorial = (type: TutorialType) => {
		this._visibleTutorial = type;
		this._activeStep = 0;

		const isUserViewedWelcomeModal = JSON.parse(
			localStorage.getItem(HP_TUTORIAL) || "false"
		) as boolean;

		if (isUserViewedWelcomeModal && type === TutorialType.HEAVE_PREDICTOR) return;

		localStorage.setItem(HP_TUTORIAL, JSON.stringify(true));
	};

	closeTutorial = () => {
		this._visibleTutorial = null;
		this._activeStep = 0;
	};

	setActiveStep = (step: number) => {
		this._activeStep = step;
	};
}
